export const DEFAULT_COUNTS = {
    sab: 6,
    sa: 4,
    sum: 4,
};

export const DRAG_STEPS = {
    sab: 0.0551,
    sa: 0.050174,
    sum: null,
};

export const MIN_MAX_STELLAZHI = {
    sab: {
        1750: {
            min: 10.0551,
            max: 11.5979,
        },
        1850: {
            min: 10.0551,
            max: 11.7081,
        },
    },
    sa: {
        1000: {
            min: 10.050174,
            max: 10.802784,
        },
        1500: {
            min: 10.050174,
            max: 11.304524,
        },
        1800: {
            min: 10.050174,
            max: 11.605568,
        },
        1850: {
            min: 10.050174,
            max: 11.655742,
        },
        1950: {
            min: 10.050174,
            max: 11.75609,
        },
        2000: {
            min: 10.050174,
            max: 11.806264,
        },
    },
    sum: {
        1800: {
            min: 10.169,
            max: 11.6221,
        },
    },
};

export const Y_MAP_SHELVES = {
    sab: {
        1750: {
            1: 10,
            2: 10.3306,
            3: 10.6612,
            4: 10.9918,
            5: 11.3224,
            6: 11.653,
            7: 11.4877,
            8: 11.1571,
            9: 10.8265,
            10: 10.4959,
            11: 10.1653,
        },
        1850: {
            1: 10,
            2: 10.3306,
            3: 10.7163,
            4: 11.0469,
            5: 11.4326,
            6: 11.7632,
            7: 11.4877,
            8: 11.1571,
            9: 10.8265,
            10: 10.4959,
            11: 10.1653,
        },
    },
    sa: {
        1000: {
            1: 10,
            2: 10.301,
            3: 10.6021,
            4: 10.9031, // Самая верхняя (макс позиция)
            5: 10.7526, // между 3 и 4
            6: 10.4516, // между 2 и 3
            7: 10.1505, // между 1 и 2
        },
        1500: {
            1: 10,
            2: 10.301,
            3: 10.6021,
            4: 11.404872, // Самая верхняя (макс позиция)
            5: 11.2711, // сверху вниз
            6: 11.1383,
            7: 11.0049,
            8: 10.8711,
            9: 10.7371,
        },
        1800: {
            1: 10,
            2: 10.301,
            3: 10.6021,
            4: 11.705916, // верхняя
            5: 11.5219, // сверху вниз
            6: 11.3379,
            7: 11.1539,
            8: 10.97,
            9: 10.786,
            10: 10.4516, // между 2 и 3
        },
        1850: {
            1: 10,
            2: 10.301,
            3: 10.6021,
            4: 11.75609, // верхняя
            5: 11.56376, // сверху вниз
            6: 11.37176,
            7: 11.17942,
            8: 10.98709,
            9: 10.79476,
            10: 10.4516, // между 2 и 3
        },
        1950: {
            1: 10,
            2: 10.301,
            3: 10.6021,
            4: 11.856438, // верхняя
            5: 11.64738, // сверху вниз
            6: 11.43833,
            7: 11.22938,
            8: 11.02037,
            9: 10.81138,
            10: 10.4516, // между 2 и 3
        },
        2000: {
            1: 10,
            2: 10.301,
            3: 10.6021,
            4: 11.906612, // верхняя
            5: 11.68919, // сверху вниз
            6: 11.47177,
            7: 11.25435,
            8: 11.03693,
            9: 10.81951,
            10: 10.4516, // между 2 и 3
        },
    },
    sum: {
        1800: {
            1: 10.086, // дефолтная
            2: 10.569, // дефолтная
            3: 11.1381, // дефолтная
            4: 11.7071, // верхняя дефолтная
            5: 11.4226, // доп. между 3 и 4 (верхняя из доп.)
            6: 10.8536, // доп. между 2 и 3
            7: 10.2845, // доп. между 1 и 2 (нижняя из доп.)
        },
    },
};
